<template>
  <!-- Footer Area -->

  <footer class="footer-area">
    <div class="container">
      <div class="footer-up">
        <div class="row">
          <div class="col-lg-5 col-md-6 col-sm-12">
            <div class="logo">
              <img src="/assets/img/wmk-logo-white.png" alt="Logo WMK" />
            </div>
            <div class="contact-info">
              <p><b>Adres:</b> {{ homeData.address }}</p>
              <p><b>Nr telefonu:</b> {{ homeData.phone }}</p>
              <p><b>E-mail:</b> {{ homeData.mail }}</p>
              <p><b>NIP:</b> {{ homeData.nip }}</p>
              <p><b>REGON:</b> {{ homeData.regon }}</p>
              <p><b>Nr rejestru firmy:</b> {{ homeData.nrRej }}</p>
            </div>
          </div>
          <div class="col-lg-7 col-md-6 col-sm-12">
            <div class="map-container">
              <div id="google-map" class="google-map"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <!-- Footer Bottom Area  -->

  <div class="footer-bottom">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-auto">
          <div class="copyright-area text-center">
            <p class="copyright-line">© 2025 WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska<br>Wszelkie prawa zastrzeżone</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      homeData: [],
      services: [],
    };
  },

  async mounted() {
    let fetchedData = await axios.get("/assets/data/homeData.json");
    this.homeData = fetchedData.data.homeData;

    this.$nextTick(() => {
      this.initializeMap();
    });
  },

  methods: {
    singleService() {
      this.$parent.reRenderData();

      //scrolling to top of the window
      window.scrollTo(0, 0);
    },
    
    initializeMap() {
      if (typeof google === 'undefined') {
        console.error('Google Maps API nie jest załadowane');
        return;
      }

      const location = { lat: 53.4387092590332, lng: 14.539044380187988 };

      const mapOptions = {
        zoom: 15,
        center: location,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: true,
        scaleControl: false,
        draggable: true,
        styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#242f3e"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#746855"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#242f3e"
            }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#d59563"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#d59563"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#263c3f"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#6b9a76"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#38414e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#212a37"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9ca5b3"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#746855"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#1f2835"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#f3d19c"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#2f3948"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#d59563"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#17263c"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#515c6d"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#17263c"
            }
          ]
        }
      ],
      };

      const map = new google.maps.Map(document.getElementById('google-map'), mapOptions);

      const marker = new google.maps.Marker({
        position: location,
        map: map,
        title: 'WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska',
        animation: google.maps.Animation.DROP,
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div style="padding: 10px;">
            <h6 style="margin: 0 0 5px 0; color: #333;">WMK Biuro Audytorsko - Rachunkowe | Wiesława Ciborowska</h6>
            <p style="margin: 0; color: #666; font-size: 14px;">ul. Monte Cassino 18A, pok. 111, 71-467<br>Szczecin</p>
          </div>
        `
      });

      marker.addListener('click', () => {
        infoWindow.open(map, marker);
      });
    },
  },
};
</script>
